import * as React from "react";
import { RootState, useAppDispatch } from "@services/Redux";
import { fetchProducts, setProductFilterCategory, setProducts, setProductsFilterCurrentPage } from "@services/Redux/products";
import { Menu, MenuItem, SubMenu } from "@szhsin/react-menu";
import { Category } from "@utils/types";
import { FiChevronDown } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import Styled from "./styled";

interface CategoriesMenuProps {
  categories: Category[];
}

export const CategoriesMenu: React.FC<CategoriesMenuProps> = ({ categories }) => {
  const { filters } = useSelector((state: RootState) => state.products);
  const dispatch = useAppDispatch();

  const clearCategoryFilter = () => {
    dispatch(setProductFilterCategory(null));
    dispatch(setProductsFilterCurrentPage(1));
    dispatch(setProducts([]));
    dispatch(fetchProducts());
  };

  return (
    <Menu
      menuButton={
        <Styled.SelectButton>
          <span>{filters.category ? filters.category.name : "Categorias"}</span>
          {filters.category ? (
            <Styled.CloseButton onClick={clearCategoryFilter}>
              <AiOutlineClose />
            </Styled.CloseButton>
          ) : (
            <FiChevronDown size={26} />
          )}
        </Styled.SelectButton>
      }
      transition
    >
      <CategoriesMenuItems categories={categories} />
    </Menu>
  );
};

const CategoriesMenuItems: React.FC<CategoriesMenuProps> = ({ categories }) => {
  const dispatch = useAppDispatch();

  const handleCategoryChange = (category: Category) => {
    dispatch(setProductFilterCategory(category));
    dispatch(setProductsFilterCurrentPage(1));
    dispatch(setProducts([]));
    dispatch(fetchProducts());
  };

  return (
    <>
      {categories.map((category, index) => {
        return (
          <>
            {category.children?.length > 0 ? (
              <SubMenu label={category.name} key={category.id}>
                <MenuItem
                  key={category.id}
                  onClick={() => {
                    handleCategoryChange(category);
                  }}
                >
                  Todas
                </MenuItem>
                <CategoriesMenuItems categories={category.children} />
              </SubMenu>
            ) : (
              <MenuItem
                key={category.id}
                onClick={() => {
                  handleCategoryChange(category);
                }}
              >
                {category.name}
              </MenuItem>
            )}
          </>
        );
      })}
    </>
  );
};
